import React from "react";

// A single gallery card: photo with a number + title label overlay.
export default function GalleryCard({ card, delay }) {
  return (
    <div className={`gallery-card ${card.pattern}`} data-reveal data-reveal-delay={delay}>
      <img className="gallery-img" src={card.img} alt={card.title} loading="lazy" draggable="false" />
      <div className="label">
        <span className="eyebrow">{card.n}</span>
        <h4>{card.title}</h4>
      </div>
    </div>
  );
}
